export const CATALOGUE_SCREENS = ['products', 'datasheets', 'marketing', 'price-lists'] as const;
export type CatalogueScreen = (typeof CATALOGUE_SCREENS)[number];

export function privateFileHash(asset: number, revision: number) { return `#/catalogue/file/${asset}/${revision}`; }
export function decodePrivateFileHash(hash: string): { asset: number; revision: number } | undefined {
  const match = /^#\/catalogue\/file\/([1-9]\d*)\/([1-9]\d*)(?:\?.*)?$/.exec(hash);
  if (!match) return;
  const asset = Number(match[1]), revision = Number(match[2]);
  return Number.isSafeInteger(asset) && Number.isSafeInteger(revision) ? { asset, revision } : undefined;
}

export function decodeCatalogueScreen(value: string | undefined): CatalogueScreen {
  return CATALOGUE_SCREENS.find((screen) => screen === value) ?? 'products';
}

export function encodeCataloguePath(screen: CatalogueScreen = 'products', category?: string, vertical?: string): string {
  const params = new URLSearchParams();
  if (screen === 'datasheets' && category) params.set('category', category);
  if (vertical) params.set('vertical', vertical);
  const query = params.toString();
  return `#/catalogue/${screen}${query ? `?${query}` : ''}`;
}

export function decodeCataloguePath(hash: string): { screen: CatalogueScreen; category?: string } {
  const [path, query] = hash.replace(/^#\/?/, '').split('?');
  const screen = decodeCatalogueScreen(path.split('/')[1]);
  const category = screen === 'datasheets' ? new URLSearchParams(query).get('category') || undefined : undefined;
  return { screen, ...(category ? { category } : {}) };
}
